<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t(headerLabel) }}
    </h1>

    <h2 class="text-lg md:text-xl text-primary font-medium">
      {{ $t('SearchforRequests') }}
    </h2>

    <MyRequestsSearchForm is-returned @on-submit="onSubmit" />

    <RequestTable
      :isLoading="isLoading"
      :tableData="tableData"
      :initialValues="initialValues"
      :modules
      :parentService
      :services
      :transaction
      :shipmentStatus
      :deliveryCompanies
      :pageLength="pageLength"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'
import MyRequestsSearchForm from '@/views/individual/my-requests/MyRequestsSearchForm.vue'
import axiosInstance from '@/services'
import RequestTable from '@/views/individual/my-requests/RequestTable.vue'

const props = defineProps({
  isReturned: Boolean
})

const isLoading = ref(true)
const tableData = ref([])

const headerLabel = computed(() => (props.isReturned ? 'returnedRequests' : 'myRequests'))

async function fetchRequests(
  payload = {
    pageSize: 10,
    currentPage: 1
  }
) {
  return await axiosInstance.post('/api/individual/request/search', payload)
}

async function onSubmit(payload) {
  isLoading.value = true
  tableData.value = await fetchRequests(payload)

  isLoading.value = false
}
</script>

<style lang="scss" scoped></style>
